import { LayoutDashboard, User, Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { useWebSocketStatus } from '../../hooks/useWebSocket';

export function Header() {
  const { connected, lastUpdateTime, scheduleVersion } = useWebSocketStatus();

  return (
    <header className="h-14 border-b border-border px-4 flex items-center justify-between bg-background sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <LayoutDashboard className="h-6 w-6 text-primary" />
        <h1 className="text-lg font-semibold">Production Scheduler</h1>
      </div>

      <div className="flex items-center gap-4">
        {/* Connection Status */}
        <div className="flex items-center gap-2">
          {connected ? (
            <div className="flex items-center gap-1.5 text-success" title="Connected - Real-time updates active">
              <Wifi className="h-4 w-4" />
              <span className="text-xs font-medium">Live</span>
            </div>
          ) : (
            <div className="flex items-center gap-1.5 text-foreground-muted" title="Disconnected - Reconnecting...">
              <WifiOff className="h-4 w-4" />
              <span className="text-xs font-medium">Offline</span>
            </div>
          )}
        </div>

        {/* Last Update Time */}
        {lastUpdateTime && (
          <div
            className="flex items-center gap-1.5 text-foreground-muted"
            title={`Schedule version: ${scheduleVersion ?? 'unknown'}`}
          >
            <RefreshCw className="h-3.5 w-3.5" />
            <span className="text-xs">
              Updated {formatDistanceToNow(lastUpdateTime, { addSuffix: true })}
            </span>
          </div>
        )}

        <div className="h-4 w-px bg-border" />

        <span className="text-sm text-foreground-muted">Dashboard</span>
        <button
          className="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-background-subtle transition-colors"
          aria-label="User menu"
        >
          <User className="h-4 w-4" />
          <span className="text-sm">Leadership</span>
        </button>
      </div>
    </header>
  );
}
